export default __webpack_public_path__ + "static/media/pbx.4a00f59d.svg";